const shareHandler = (path, key) => {
  var text = "https://www.threshold.fm/" + path + "/" + key;
  window.prompt("Copy to clipboard: Ctrl+C, Enter", text);
};

export default shareHandler;
